<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="1000" scrollable>
      <v-card>
        <v-toolbar dark dense>
          <v-toolbar-title class="headline"
            >Edit store information</v-toolbar-title
          >
          <v-spacer />
          <v-icon @click="cancel()">close</v-icon>
        </v-toolbar>
        <v-tabs v-model="tabs" grow light color="primary" v-if="close_cropper">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
        </v-tabs>
        <v-card-text style="height: auto" v-if="close_cropper">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-tabs-items v-model="tabs">
              <v-tab-item v-for="n in lang" :key="n">
                <div style="padding: 1px; background-color: #eeeeee">
                  <v-layout row>
                    <v-flex xs6 class="mr-2">
                      <v-text-field
                        v-model="edit_form['store_name_' + n]"
                        :label="'Store name' + '(' + n + ')'"
                        :rules="
                          n == 'th' || n == 'en'
                            ? edit_form['store_name_' + n]
                              ? [rules.required, rules.max]
                              : [rules.required]
                            : edit_form['store_name_' + n]
                            ? [rules.max]
                            : []
                        "
                        counter="55"
                      ></v-text-field>
                      <v-select
                        @change="
                          selectServices(edit_form.store_store_service_id)
                        "
                        v-model="edit_form.store_store_service_id"
                        :items="storeserviceItems"
                        item-text="store_service_name_th"
                        item-value="store_service_id"
                        label="Store service"
                        style="margin-top: 9px"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="ml-2">
                      <v-textarea
                        v-model="edit_form['store_description_' + n]"
                        name="description"
                        label="Description"
                        rows="5"
                        :rules="
                          edit_form['store_description_' + n]
                            ? [rules.max_description]
                            : []
                        "
                        counter="255"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </div>
              </v-tab-item>
            </v-tabs-items>
            <!-- select type chip -->
            <v-select
              v-model="edit_form.store_type_new"
              :items="types"
              chips
              item-text="store_type_name_th"
              item-value="store_type_id"
              label="Store type"
              multiple
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="remove(data.item, data.index)"
                >
                  <span>{{ data.item.store_type_name_th }}</span>
                </v-chip>
              </template>
            </v-select>
            <!-- END select type chip -->
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-select
                  v-model="edit_form.store_active"
                  :items="storestatusItems"
                  item-text="name"
                  item-value="value"
                  label="Store status"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-select
                  v-model="edit_form.store_package_id"
                  :items="packageItems"
                  item-text="package_name"
                  item-value="package_id"
                  label="Package"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm6>
                <div style="position: relative">
                  <label
                    style="
                      font-size: 17px;
                      position: absolute;
                      top: 15px;
                      color: #616a6b;
                    "
                    >Price range :</label
                  >
                </div>
                <v-layout row>
                  <v-flex xs12 style="margin-left: 110px; padding-right: 24px">
                    <v-layout row justify-start>
                      <v-flex xs6>
                        <v-text-field
                          solo
                          hide-details
                          v-model="edit_form.store_price_range_start"
                          placeholder="Min price"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 class="text-xs-center py-2">
                        <v-icon small>remove</v-icon>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          solo
                          hide-details
                          v-model="edit_form.store_price_range_end"
                          placeholder="Max price"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6>
                <v-layout row justify-start>
                  <v-flex xs12 md12 class="px-1">
                    <v-select
                      v-model="edit_form.store_use_pos"
                      label="Use POS"
                      item-text="name"
                      item-value="value"
                      :items="use_pos"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  v-model="edit_form.store_vat"
                  label="VAT"
                  class="pr-2"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  v-model="edit_form.store_service_charge"
                  class="inputPrice pl-2"
                  type="number"
                  label="Store service charge"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-layout row>
                  <v-flex xs12 sm6 class="mr-2">
                    <div style="position: relative">
                      <!-- <label
                        style="font-size:17px;position:absolute;top:15px;color:#616A6B;"
                      >Owner name : &nbsp; {{edit_form.store_user_name == null ? 'ไม่มีชื่อผู้ใช้' : edit_form.store_user_name }}</label> -->
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <!-- <v-select
                      clearable
                      v-model="edit_form.store_user_id"
                      :loading="fetching_data == true ? 'black' : false"
                      label="Select new user owner"
                      item-text="user_first_name"
                      item-value="user_id"
                      :items="customer_only_list"
                      :disabled="fetching_data"
                    ></v-select> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 sm6 class="pr-2">
                <div
                  v-for="(email, index) in edit_form.store_email"
                  :key="index"
                  style="display: flex; align-items: center"
                >
                  <v-text-field
                    v-model="email.email"
                    :label="`Email ${index + 1}`"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-btn
                    icon
                    color="green"
                    v-if="index == 0"
                    @click="edit_form.store_email.push({ email: '' })"
                    ><v-icon style="color: white">add</v-icon></v-btn
                  >
                  <v-btn
                    icon
                    color="red"
                    v-else
                    @click="edit_form.store_email.splice(index, 1)"
                    ><v-icon style="color: white">remove</v-icon></v-btn
                  >
                </div>
              </v-flex>
              <v-flex
                xs12
                sm6
                class="pl-2"
                v-for="(info, index) in edit_form.store_tel"
                :key="index"
              >
                <v-layout row align-center class="text-xs-center">
                  <v-flex xs10>
                    <v-text-field
                      mask="### - #######"
                      v-model="info.tel"
                      :label="'Tel.' + (index + 1) + ' : '"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      icon
                      small
                      color="green"
                      @click="edit_form.store_tel.push({ tel: '' })"
                      v-if="index == 0"
                    >
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="red"
                      v-else
                      @click="edit_form.store_tel.splice(index, 1)"
                    >
                      <v-icon color="white">remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <div style="position: relative">
              <label
                style="
                  font-size: 17px;
                  position: absolute;
                  top: 15px;
                  color: #616a6b;
                "
                >Upload Logo Image :</label
              >
            </div>
            <v-layout row wrap style="margin-left: 150px" align-baseline>
              <v-flex xs12 class="pl-2 text-xs-left">
                <v-btn @click="$refs.LogoInput.click()">Choose Files</v-btn>
                <input
                  style="display: none"
                  type="file"
                  @change="onLogoSelected"
                  ref="LogoInput"
                  accept="image/*"
                />
              </v-flex>
              <v-flex xs12 class="pl-3">
                <span>{{ edit_form_image.logo_name }}</span>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-text v-if="!close_cropper">
          <imageCropper
            :aspectRatio="480 / 320"
            :imageName="image_name"
            :imgSrc="imgSrc"
            :height="300"
            @close="close_cropper = true"
            @setImageName="image_name = $event"
            @getCroped="getCropped($event)"
            v-if="imgSrc != ''"
          ></imageCropper>
        </v-card-text>
        <v-divider v-if="close_cropper"></v-divider>
        <v-card-actions v-if="close_cropper">
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="cancel()" :disabled="editing"
            >cancel</v-btn
          >
          <v-btn
            color="green"
            :disabled="isEditStoreList"
            flat
            @click="save()"
            :loading="editing"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    imageCropper,
  },
  props: ["dialog", "edit_form", "edit_form_image"],
  data() {
    return {
      editing: false,
      imgSrc: "",
      image_name: "",
      close_cropper: true,
      show: true,
      change_owner: 0,
      change_image: 0,
      use_pos: [
        {
          name: "No use/Upload Document",
          value: 0,
        },
        {
          name: "Store information",
          value: 1,
        },
        {
          name: "Use",
          value: 3,
        },
      ],
      fetching_data: false,
      rules: {
        required: (value) => !!value || "Required.",
        max: (value) =>
          value.length <= 55 || "Maximum length is 55 characters.",
        max_description: (value) =>
          value.length <= 255 || "Maximum length is 255 characters.",
      },
      valid: true,
      storename: "",
      storetypeItems: [
        {
          name: "อาหารไทย",
          value: 1,
        },
        {
          name: "อาหารจานเดียว",
          value: 2,
        },
      ],
      storestatusItems: [
        {
          name: "Active",
          value: true,
        },
        {
          name: "Inactive",
          value: false,
        },
      ],
      minprice: "",
      maxprice: "",
      servicecharge: "",
      vat: "",
      country_tel: ["+66"],
      email: "",
      tabs: null,
      lang: ["th", "en", "cn"],
      chips: "",
      bannerdate1: new Date().toISOString().substr(0, 10),
      bannerdate2: new Date().toISOString().substr(0, 10),
      bannermenu1: false,
      bannermenu2: false,
      types: [],
    };
  },

  computed: {
    ...mapState({
      customer_only_list: (state) => state.fetchCustomerBack.customer_only_list,
      storeserviceItems: (state) => state.fetchStoreBack.store_services,
      store_types: (state) => state.fetchStoreBack.store_type.store_types,
      packageItems: (state) => state.fetchPackageBack.package_data,
      store_detail: (state) => state.fetchStoreBack.store_detail,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        this.change_image = 0;
        this.fetching_data = true;
        // await this.$store.dispatch("fetchCustomerBack/getOnlyCustomerList");
        this.fetching_data = false;
      }
    },
    edit_form: {
      handler: function () {
        this.types = [];
        for (let i in this.store_types) {
          if (
            this.store_types[i].store_type_service_id ==
            this.edit_form.store_store_service_id
          ) {
            this.types.push(this.store_types[i]);
          }
        }
      },
      deep: true,
    },
    store_detail: {
      handler: function () {
        this.types = [];
        for (let i in this.store_types) {
          if (
            this.store_types[i].store_type_service_id ==
            this.store_detail.store_service.store_service_id
          ) {
            this.types.push(this.store_types[i]);
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    stringEmptyToNull(form) {
      for (let val in form) {
        if (typeof form[val] == "string" && form[val] == "") {
          form[val] = null;
        }
        if (typeof form[val] == "object" && form[val] != null) {
          for (let arr in form[val]) {
            for (let val1 in form[val][arr]) {
              if (
                typeof form[val][arr][val1] == "string" &&
                form[val][arr][val1] == ""
              ) {
                form[val][arr][val1] = null;
              }
              if (
                typeof form[val][arr][val1] == "object" &&
                form[val][arr][val1] != null
              ) {
                for (let arr2 in form[val][arr][val1]) {
                  for (let val2 in form[val][arr][val1][arr2]) {
                    if (
                      typeof form[val][arr][val1][arr2][val2] == "string" &&
                      form[val][arr][val1][arr2][val2] == ""
                    )
                      form[val][arr][val1][arr2][val2] = null;
                  }
                }
              }
            }
          }
        }
      }
      return form;
    },
    cancel() {
      this.$emit("setDialog", false);
      this.$emit("cancelEditInfo");
    },
    selectServices(service_id) {
      this.edit_form.store_type_new = [];
      this.types = [];
      for (let i in this.store_types) {
        if (this.store_types[i].store_type_service_id == service_id) {
          this.types.push(this.store_types[i]);
        }
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        for (let x in this.edit_form) {
          if (this.edit_form[x] != 0) {
            if (this.edit_form[x] == "" || this.edit_form[x] == null) {
              delete this.edit_form[x];
            }
          }
        }
        let obj1 = JSON.parse(JSON.stringify(this.edit_form));
        delete obj1.store_user_name;
        let stringEmail = "";
        for (let key in obj1.store_email) {
          stringEmail = stringEmail + obj1.store_email[key].email;
          if (key != obj1.store_email.length - 1) {
            stringEmail = stringEmail + ",";
          }
        }

        if (obj1.store_use_pos == 0) {
          obj1.store_on_hold_msg = "hold_document";
          obj1.store_reject_msg = null;
        } else {
          obj1.store_on_hold_msg = null;
          obj1.store_reject_msg = null;
        }

        obj1.store_email = stringEmail;
        this.editing = true;
        obj1 = await this.stringEmptyToNull(obj1);
        await this.$store.dispatch("fetchStoreBack/editStoreInfo", obj1);
        this.editing = false;
        this.$emit("saveEditInfo");
        this.$emit("setDialog", false);
      }
    },
    getCropped(image_value) {
      this.edit_form_image.logo_name = this.image_name;
      this.edit_form.store_image = image_value;
      this.change_image = 1;
      this.image_name = "";
    },
    onLogoSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgSrc = reader.result;
        this.close_cropper = false;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    remove(data, index) {
      this.edit_form.store_type_new.splice(index, 1);
      this.edit_form.store_type_new = [...this.edit_form.store_type_new];
    },
  },
  created() {},
};
</script>
<style scoped>
.timePicker {
  margin-top: 15px;
}
.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}
.time-picker input.display-time {
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}

.inputPrice input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
